import React from 'react';
import { Nav, Navbar } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import finaLogo from "../../assets/images/FinaLogo.png";
import axiosInstance from '../../api/utils/axiosInstance'
import FileSaver from 'file-saver'
import "./Navigation.css"

const navigation = (props) => {

    return (
        <Navbar className="navbar" collapseOnSelect expand="lg" variant="light" aria-label="Navigacijska traka">
            <div className='logo_ospd'>
                <Navbar.Brand href="https://www.fina.hr">
                    <img className="logo" src={finaLogo} alt="FINA početna stranica" />
                </Navbar.Brand>

                <Navbar.Brand href="/" className="d-none d-md-block">
                    <div className="ospd">Online servis za predaju dokumentacije</div>
                </Navbar.Brand>
                <Navbar.Brand href="/" className="d-md-none">
                    <div className="ospd">OSPD</div>
                </Navbar.Brand>
            </div>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse className="collapse-navbar justify-content-end" id="responsive-navbar-nav">
                <Nav>
                    <NavLink className="nav-text toggle-button:focus" activeClassName="selected" to="/" exact={true}>Zahtjev za predaju</NavLink>
                    <NavLink className="nav-text toggle-button:focus" activeClassName="selected" to="/status">Provjera statusa</NavLink>
                    <NavLink className="nav-text toggle-button:focus" activeClassName="" to="/"  onClick={(e) => {
                        e.preventDefault();
                        axiosInstance.get("/tos/1").then(res => {
                            var binaryString = window.atob(res.data.pdf);
                            var binaryLen = binaryString.length;
                            var bytes = new Uint8Array(binaryLen);
                            for (var i = 0; i < binaryLen; i++) {
                                var ascii = binaryString.charCodeAt(i);
                                bytes[i] = ascii;
                            }
                            var newBlob = new Blob([bytes], { type: "application/pdf" });

                            FileSaver.saveAs(newBlob, res.data.fileName);
                        })
                    }}>Upute</NavLink>
                    <NavLink className="nav-text toggle-button:focus" activeClassName="" to="/"  onClick={(e) => {
                        e.preventDefault();
                        axiosInstance.get("/tos/2").then(res => {
                            var binaryString = window.atob(res.data.pdf);
                            var binaryLen = binaryString.length;
                            var bytes = new Uint8Array(binaryLen);
                            for (var i = 0; i < binaryLen; i++) {
                                var ascii = binaryString.charCodeAt(i);
                                bytes[i] = ascii;
                            }
                            var newBlob = new Blob([bytes], { type: "application/pdf" });

                            FileSaver.saveAs(newBlob, res.data.fileName);
                        })
                    }}>Uvjeti korištenja</NavLink>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default navigation;